import DummyIFrame from '../DummyIFrame';
import IFrame from '../IFrame';
import React from 'react';
import { AssessmentPageLayoutProps } from '../AssessmentPage';
import { BrandColors } from '../../../constants';
import { FullPageLoader } from '../../../common/components';

/** Component for playing Assessment in Iframe */
export const AssessmentPageLayout01 = (props: AssessmentPageLayoutProps): JSX.Element => {
  const { loading, parsedLaunchAssessmentConfig, launchurl } = props;

  /** show loader until url is validated */
  if (loading || !parsedLaunchAssessmentConfig || !launchurl) {
    return <FullPageLoader backdropColor={BrandColors.white} isLoading={true} />;
  }

  let src = launchurl;
  if (!src.includes(process.env.REACT_APP_PLAYER_API_DOMAIN || window.location.origin)) {
    src = `${process.env.REACT_APP_PLAYER_API_DOMAIN || window.location.origin}${launchurl}`;
  }

  if (
    process.env.REACT_APP_EXPERIENCE_LITE_API_DOMAIN === process.env.REACT_APP_DOMAIN &&
    process.env.NODE_ENV === process.env.REACT_APP_DEV_MODE
  ) {
    return (
      <DummyIFrame>
        <h1>Redirecting from Assessment Page...</h1>
      </DummyIFrame>
    );
  }

  return (
    <>
      <IFrame
        title={`Assessment ${parsedLaunchAssessmentConfig.projectId}`}
        id={`${parsedLaunchAssessmentConfig.packageId}`}
        src={src}
      />
    </>
  );
};
